import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p>🌇 <b>Sunset Kubernetes deployments</b></p>
      <p>
This page covers our PostHog Kubernetes deployment, which <a href="/blog/sunsetting-helm-support-posthog">we sunset and no longer support</a>. We will continue to provide security updates for Kubernetes deployments until at least May 31, 2024.
      </p>
      <details>
        <summary className="text-sm font-bold">For existing customers</summary>
        <div>We highly recommend migrating to PostHog Cloud (US or EU). Take a look at <a href="/docs/migrate/migrate-to-cloud">this guide</a> for more information on the migration process.</div>
      </details>
      <details>
        <summary className="text-sm font-bold">Looking to continue self-hosting?</summary>
        <div>We still maintain our Open-source Docker Compose deployment. Instructions for deploying can be found <a href="/docs/self-host/open-source/deployment">here</a>.</div>
      </details>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      